import { Typography, TextField, Grid } from "@mui/material";
import Button from "../common/Button";
import React, { useEffect, useState, useRef } from "react";
import "./trainingCenter.scss";
import { Stack } from "@mui/system";
import { Box, Switch } from "@mui/material";
import SearchBar from "../common/searchBar";
import ListView from "./ListView";
import CardView from "./CardView";
import Dropdown from "../../components/TP_Dropdown";
import DateRangePicker from "../../components/TP_DateRangePicker";
import ButtonModule from "../common/Button";
import TrainingCenterDetails from "./TrainingCenterDetails";
import ToggleButton from "../ToggleButton";
import { useDispatch, useSelector } from "react-redux";
import { trainingCenterAPI } from "../../redux/features/trainingCenter";
import axios from "../../globals/common_utilities/axios_old";
import moment from "moment";
import CONSTANTURL from "../../globals/common_utilities/constanturls";
import { API, FOMRS, APP_ROUTES } from "../../globals/constants";
import {
  setcheckedList,
  setemptyDeleteList,
  setemptycheckedList,
} from "../../redux/features/trainingCenter";
import Loading from "../loader";
import { useNavigate } from "react-router-dom";
import CsvDownloader from "react-csv-downloader";
import Pagination from "@mui/material/Pagination";
import { ToastContainer, toast } from "react-toastify";
import SubHeading from "../common/SubHeading";
import MultiLine_Spinner from "../multiline_spinner/Multiline_spinner";
import DeleteAlert from "../DeleteAlert/DeleteModal";
import SingleDelete from "../SingleDeleteAlert/SingleDelete";

const TrainingCenter = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [pageCount, setPageCount] = useState();
  const limit = 12;
  const [checked, setChecked] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [apiResponse, setApiResponse] = useState([]);
  const [exportApiResponse, setExportApiResponse] = useState([]);
  const [loading, setloading] = useState(true);
  const [flag, setFlag] = useState(true);
  const [Abc, setabc] = useState(true);
  const [selectLocation, setSelectLocation] = useState([]);
  const [location_id, setLocation_id] = useState();
  const selectInputRef = useRef();
  const [loadApi, setloadApi] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showSingleModal, setShowSingleModal] = useState(false);
  const [singleDeleteId, setSingleDeleteId] = useState();
  let currentDate = new Date();

  let previousDate = new Date();
  let lastday = previousDate.setDate(previousDate.getDate() - 7);
  const [queryParamas, setqueryParamas] = useState({
    limit: limit || 12,
    offset: 0,
    is_active: true,
    // from_date: moment(previousDate).format('YYYY-MM-DD'),
    // end_date: moment(currentDate).format('YYYY-MM-DD'),
  });

  const [exportqueryParams, setExportQueryParams] = useState({});

  const getLocation = async () => {
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.GET_LOCATION +
        `?` +
        `is_active=true`,
      {},
      {},
      {}
    )
      .then((response) => {
        const location = response?.data?.data?.rows?.map((value) => ({
          id: value?.id,
          value: value?.address,
          label: value?.address,
        }));
        setSelectLocation(location);
      })
      .catch((err) => {
        console.log("err::", err);
        toast.error("LOCATION NOT FOUND", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  let multipleDelete = useSelector(
    (state) => state.trainingCenterDetails?.deleteList
  );

  let multipleChecked = useSelector(
    (state) => state.trainingCenterDetails?.checkedList
  );

  const [selectedID, setSelectedID] = useState(setcheckedList);

  const switchHandler = (event) => {
    setChecked(event.target.checked);
  };

  const { loginResponse } = useSelector((state) => {
    return state.login;
  });

  let studioDetails = useSelector(
    (state) => state.trainingCenterDetails?.showdetails
  );

  const exportApiCall = async () => {
    console.log("exportApiCall");
    let qp = queryParamas;
    const from_date_Key = "from_date" in qp;
    const end_date_Key = "end_date" in qp;
    const name_Key = "name" in qp;
    const location_id_Key = "location_id" in qp;

    if (from_date_Key || end_date_Key || name_Key || location_id_Key) {
      delete qp.limit;
      delete qp.offset;
    }
    // let currentDate = new Date();

    // let previousDate = new Date();
    // previousDate.setDate(previousDate.getDate() - 7);
    // console.log('previousDate', previousDate);
    // delete qp.offset;

    // qp.from_date = moment(previousDate).format('YYYY-MM-DD');
    // qp.end_date = moment(currentDate).format('YYYY-MM-DD');
    // console.log('qp', qp);
    setloading(true);
    console.log("exportqueryParams", exportqueryParams);
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.TRAININGCENTERMASTER_ENDPOINT,
      qp,
      {},
      {}
    )
      .then((response) => {
        console.log(
          "TrainingCenterExport::::::::::",
          response?.data?.data?.rows
        );
        setExportApiResponse(response?.data?.data?.rows);
        // setPageCount(() => Math.ceil(response?.data?.data?.count / limit) );
        setloading(false);
        return response.data;
      })
      .catch(() => {
        toast.error("NO RECORD FOUND", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  const apiCall = async () => {
    const name_Key = "name" in queryParamas;
    if (name_Key) {
      delete queryParamas.offset;
    }
    console.log("apiCall");
    queryParamas.limit = 12;
    // let qp = queryParamas;
    // delete qp.limit;
    // let currentDate = new Date();

    // let previousDate = new Date();
    // previousDate.setDate(previousDate.getDate() - 7);
    // console.log('previousDate', previousDate);
    // delete qp.offset;

    // qp.from_date = moment(previousDate).format('YYYY-MM-DD');
    // qp.end_date = moment(currentDate).format('YYYY-MM-DD');
    // setqueryParamas({ ...qp });
    // let qp = queryParamas;
    // let currentDate = new Date();

    // let previousDate = new Date();
    // previousDate.setDate(previousDate.getDate() - 40);
    // console.log('previousDate', previousDate);

    // qp.from_date = moment(previousDate).format('YYYY-MM-DD');
    // qp.end_date = moment(currentDate).format('YYYY-MM-DD');
    // setqueryParamas({ ...qp });
    setloading(true);

    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.TRAININGCENTERMASTER_ENDPOINT,
      queryParamas,
      {},
      {}
    )
      .then((response) => {
        console.log("TrainingCenter", response?.data?.data?.rows);
        setApiResponse(response?.data?.data?.rows);
        setPageCount(() => Math.ceil(response?.data?.data?.count / limit));
        setloading(false);
        return response.data;
      })
      .catch(() => {
        toast.error("NO RECORD FOUND", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  const singleDelete = (list) => {
    setSingleDeleteId(list);
    setShowSingleModal(true);
  };

  const multipleDeleteList = async (list) => {
    if (multipleDelete.length < 1) {
      toast.error("Select Records To Delete ", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      setShowModal(true);
    }
  };

  const searchStudio = async (StudioName) => {
    //console.log('searchStudio', StudioName);
    let params = queryParamas;
    let exportParams = exportqueryParams;

    StudioName ? (params.name = `${StudioName}`) : delete params.name;
    StudioName
      ? (exportParams.name = `${StudioName}`)
      : delete exportParams.name;

    setqueryParamas({ ...params });
    setExportQueryParams({ ...exportParams });
  };

  const dropdownSelect = async (getLocation) => {
    //console.log('DROPDOwnselectLocation', getLocation);
    let params = queryParamas;
    let exportParams = exportqueryParams;
    getLocation?.id
      ? (params.location_id = `${getLocation?.id}`)
      : delete params.location_id;
    getLocation?.id
      ? (exportParams.location_id = `${getLocation?.id}`)
      : delete exportParams.location_id;
    //console.log('params', params);
    setqueryParamas({ ...params });
    setExportQueryParams({ ...exportParams });
  };

  const onPageClickhandler = (e, data) => {
    setqueryParamas((prevState) => ({
      ...prevState,
      offset: Math.ceil((data - 1) * limit),
    }));
  };

  const datefilter = async (range) => {
    let startDate = range[0];
    let endDate = range[1];
    let params = queryParamas;
    // let exportParams = exportqueryParams;

    // let currentDate = new Date();

    // let previousDate = new Date();
    // previousDate.setDate(previousDate.getDate() - 7);
    range[0]
      ? (params.from_date = `${moment(startDate).format("YYYY-MM-DD")}`)
      : delete params.from_date;

    range[1]
      ? (params.end_date = `${moment(endDate).format("YYYY-MM-DD")}`)
      : delete params.from_date;

    // if (range[0]) {
    // 	params.from_date = `${moment(startDate).format('YYYY-MM-DD')}`;
    // }

    // if (range[1]) {
    // 	params.end_date = `${moment(endDate).format('YYYY-MM-DD')}`;
    // }

    //exportParams.end_date = `${endDate}`;
    setqueryParamas({ ...params });
    setPageCount("");
    // setExportQueryParams({ ...exportParams });
  };

  const exportFile = () => {
    exportApiCall();
    dispatch(setemptyDeleteList());
    dispatch(setemptycheckedList());
  };

  const clearButton = () => {
    document.getElementById("TrainingCenterCLearFilter").click();
    document.getElementById("TrainingCenterCLearDate").click();
    setShowFilter(!showFilter);
  };

  useEffect(() => {
    if (loadApi) {
      apiCall();
      exportApiCall();
    } else {
      setloadApi(true);
    }
  }, [queryParamas]);
  // useEffect(() => {
  // 	if (loadApi) {
  // 		exportApiCall();
  // 	} else {
  // 		setloadApi(true);
  // 	}
  // }, [exportqueryParams]);

  useEffect(() => {
    if (window.innerWidth < 770) {
      setChecked(true);
    } else {
      setChecked(false);
    }
  }, [window.innerWidth]);

  useEffect(() => {
    getLocation();
  }, []);

  useEffect(() => {
    console.log("studioData ", studioDetails);
    if(studioDetails && showFilter){
      clearButton();
    }
  }, [studioDetails]);
  
  const columns = [
    { displayName: "Training center name", id: "studio_name" },
    { displayName: "Date", id: "created_at" },

    {
      displayName: "No. of Scheduled training",
      id: "training_count",
    },
    {
      displayName: "No. of Student Attended",
      id: "student_count",
    },
    { displayName: "Location", id: "location.location" },
    {
      displayName: "No. of training days",
      id: "training_days",
    },
  ];

  let datas = multipleChecked.length > 0 ? multipleChecked : exportApiResponse;
  const closemodal = () => {
    setShowModal(false);
    setShowSingleModal(false);
  };

  const deleteList = async () => {
    const response = await axios(
      "DELETE",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.TRAININGDELETE_ENDPOINT +
        `?` +
        `ids=[${multipleDelete.map((value) => `"${value}"`)}]`,
      {},
      {},
      {}
    )
      .then((response) => {
        // console.log('TrainingCenter', response?.data?.data?.rows);
        // setApiResponse(response?.data?.data?.rows);
        // setloading(false);
        toast.success("Records Deleted", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        apiCall();
        setFlag(!flag);
        setShowModal(false);
        dispatch(setemptyDeleteList());
        dispatch(setemptycheckedList());
        return response.data;
      })
      .catch(() => {
        setShowModal(false);
        toast.error("RECORDS NOT DELETED", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  const singleDeleteModal = async () => {
    const response = await axios(
      "DELETE",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDIO +
        API.END_POINTS.TRAININGDELETE_ENDPOINT +
        `?` +
        `ids=["${singleDeleteId}"]`,
      {},
      {},
      {}
    )
      .then((response) => {
        toast.success("Record Deleted", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        setShowSingleModal(false);
        apiCall();
        setFlag(!flag);
        return response.data;
      })
      .catch(() => {
        setShowSingleModal(false);
        toast.error("RECORD NOT DELETED", {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
      });
  };

  return (
    <>
      {showModal ? (
        <DeleteAlert closeModal={closemodal} deleteList={deleteList} />
      ) : (
        ""
      )}
      {showSingleModal ? (
        <SingleDelete
          closeModal={closemodal}
          singleDeleteModal={singleDeleteModal}
        />
      ) : (
        ""
      )}
      <div className="scrollContainer">
        <Stack direction="row" spacing={"20%"}>
          {studioDetails ? (
            ""
          ) : (
            <SubHeading
              title={"Training Center"}
              checked={checked}
              switchHandler={switchHandler}
              gridview={switchHandler}
              searchChange={searchStudio}
              multipleDeleteList={multipleDeleteList}
              columns={columns}
              datas={datas}
              exportFile={exportFile}
              redirect={APP_ROUTES.ADD_TRAINING_CENTRE}
              setShowFilter={setShowFilter}
              showFilter={showFilter}
              exportfileTitle={"Studio_Master_Data"}
              addText={"Add Center"}
            />
          )}
        </Stack>
        <div style={{ display: showFilter ? "contents" : "none" }}>
          <Grid container className="datepickercontainer_filter">
            {console.log("vvbvbvnvvvvvnnnvbv---", pageCount)}
            <Grid item xs={12} sm={12} md={12} lg={12} spacing="5">
              <Grid container justifyContent="start">
                <Grid item xs={12} sm={12} md={5} lg={5}>
                  <DateRangePicker
                    getdateRange={datefilter}
                    clearID={"TrainingCenterCLearDate"}
                    // startDateProps={lastday}
                    // endDateProps={currentDate}
                  />
                </Grid>
                <Grid container xs={12} sm={12} md={7} lg={7} columnSpacing={4}>
                  <Grid item xs={12} sm={1} md={1} lg={1}>
                    <Stack
                      justifyContent={"flex-start"}
                      alignItems={"flex-start"}
                      marginRight={"55%"}
                      marginTop={"5%"}
                      className="grayBorder"
                      sx={{ borderRight: "2px solid #2C2C2C ", height: "40px" }}
                    ></Stack>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6}>
                    <Dropdown
                      ref={selectInputRef}
                      placeholder="Location"
                      options={selectLocation}
                      selectDropDown={dropdownSelect}
                      clearID={"TrainingCenterCLearFilter"}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sm={4}
                    md={4}
                    lg={4}
                    className="clearFlex"
                    justifyContent={{
                      xs: "flex-end",
                      md: "flex-end",
                      lg: "flex-start",
                    }}
                  >
                    <Button
                      id="TrainingCenterCLearFilter"
                      className="fs-4"
                      value="Clear Filter"
                      role="clearFilter"
                      onClick={() => {
                        clearButton();
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </div>

        <>
          {studioDetails ? (
            <TrainingCenterDetails
              res={apiResponse}
              ondeleteClick={singleDelete}
            />
          ) : (
            <Box
              sx={{ bgcolor: "#232135", height: "100vh" }}
              className="tc_mainBox"
            >
              {checked ? (
                <>
                  {loading ? (
                    <MultiLine_Spinner />
                  ) : (
                    <Stack direction="row" flexWrap="wrap">
                      <CardView
                        res={apiResponse}
                        lgWidth={"4"}
                        ondeleteClick={singleDelete}
                      />
                    </Stack>
                  )}
                </>
              ) : (
                <>
                  {loading ? (
                    <MultiLine_Spinner />
                  ) : (
                    <Stack>
                      {apiResponse?.length > 0 ? (
                        apiResponse?.map((res) => {
                          return (
                            <>
                              <Stack
                                onClick={() => {
                                  setShowDetails(true);
                                }}
                              >
                                <ListView
                                  res={res}
                                  ondeleteClick={singleDelete}
                                />
                              </Stack>
                            </>
                          );
                        })
                      ) : (
                        <Stack className="NO_RECORD_FOUND">
                          No Record Found
                        </Stack>
                      )}
                    </Stack>
                  )}
                </>
              )}
            </Box>
          )}
          {/* {studioDetails == false ? (
					<Stack alignItems="end" marginTop={'-1%'} marginRight={'1%'}>
						<Pagination count={pageCount} onChange={onPageClickhandler} />
					</Stack>
				) : (
					''
				)} */}
        </>
      </div>
      {studioDetails == false ? (
        <Stack alignItems="end" marginTop={"0.5%"} marginRight={"1%"}>
          <Pagination
            count={pageCount}
            onChange={onPageClickhandler}
            disabled={pageCount === 1}
          />
        </Stack>
      ) : (
        ""
      )}
    </>
  );
};

export default TrainingCenter;
